import { render, staticRenderFns } from "./Alzheimer.vue?vue&type=template&id=9c2cd038&scoped=true"
var script = {}
import style0 from "./Alzheimer.vue?vue&type=style&index=0&id=9c2cd038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2cd038",
  null
  
)

export default component.exports